import * as React from "react";
import { connect } from "react-redux";
import { TopLink } from "..";

function BackToHousehold({ householdId, currentHousehold }) {
  if (!householdId) {
    return null;
  }

  if (
    currentHousehold &&
    (currentHousehold.rror === 0 || currentHousehold.risk === 0)
  ) {
    return null;
  }

  return (
    <TopLink path={`/Portal/household/${householdId}`} text="Back to Household" />
  );
}

const mapStateToProps = (state, props) => {
  return {
    currentHousehold: state.household.currentHousehold,
  };
};

export default connect(mapStateToProps)(BackToHousehold);



// WEBPACK FOOTER //
// ./src/containers/Cy/components/BackToHousehold/index.jsx